export const Regexs = {
  numberWithCommas: /\B(?=(\d{3})+(?!\d))/g,
  onlyNumberWithCommas: /^([0-9]|\,)+$/,
  numberNotStartWithZero: /^(0|(-?[1-9][0-9]*))$/,
};
